import { noop } from 'underscore';
import { useEffect, useState, useRef } from 'react';

export const useIntersectionObserver = ({
  ref,
  onScrollToView = noop,
  options,
}) => {
  const { threshold = 0.5 } = options || {};
  const [isIntersecting, setIsIntersecting] = useState(false);
  const observer = useRef(null);

  useEffect(() => {
    observer.current = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting);
    }, { threshold });

    const currentRef = ref.current;
    if (currentRef) {
      observer.current.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.current.unobserve(currentRef);
      }
    };
  }, [ref, threshold]);

  useEffect(() => {
    if (isIntersecting) {
      onScrollToView();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isIntersecting]);

  return isIntersecting;
};
